import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const TwitterCircle32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      className={cn(
        chroma === 'default' && s.twitterFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M15.84 1.44c7.947 0 14.4 6.453 14.4 14.4s-6.453 14.4-14.4 14.4-14.4-6.453-14.4-14.4 6.453-14.4 14.4-14.4zm2.895 8.64c-1.532 0-2.809 1.284-2.809 2.898 0 .22.037.44.073.66-2.335-.11-4.377-1.283-5.764-3.008-.255.44-.365.917-.365 1.468 0 .99.511 1.87 1.24 2.421-.473 0-.875-.147-1.276-.367v.037c0 1.394.949 2.568 2.262 2.825-.219.073-.474.11-.73.11-.182 0-.365 0-.51-.037.364 1.138 1.386 1.982 2.626 2.018a5.489 5.489 0 01-3.466 1.248c-.218 0-.437 0-.656-.037a7.823 7.823 0 004.305 1.284c5.143 0 7.989-4.403 7.989-8.218v-.367a5.446 5.446 0 001.386-1.504c-.51.22-1.058.404-1.605.44.474-.44.912-.99 1.13-1.65-.546.33-1.13.586-1.787.696-.51-.55-1.24-.917-2.043-.917z"
      fillRule="evenodd"
    />
  </svg>
);

export default TwitterCircle32;
